import { http } from './http'

export type UserResponse = {
  user_id: string
  avatar: string
  name: string
  nickname: string
  email: string
  token: Object
}

export const apiFastLogin = (data: { credential: string }) => {
  return http.post<UserResponse>('/api/user/fast/login/google', { data })
}

export const apiLogin = (data: {
  code: string
  state: string
  redirect_uri: string
}) => {
  let provider = data?.state?.toLowerCase(),
    path = '/api/user/login/google'
  if (provider.includes('apple')) {
    path = '/api/user/login/apple'
  }
  return http.post<UserResponse>(path, { data })
}

export const apiFetchEmailCode = (data: { email: string; team: string }) => {
  return http.post<any>('/api/user/email/send/verification', { data })
}

export const apiLoginWithEmail = (data: {
  email: string
  code: string
  client_code: string
}) => {
  return http.post<any>('/api/user/login/email', { data })
}

export const apiLogout = (data?: object) => {
  return http.post<UserResponse>('/api/user/logout', { data })
}

export const apiChangePassword = (data?: object) => {
  return http.post<UserResponse>('/api/user/change_pwd', { data })
}

export const apiRefreshToken = (data: { refresh_token: string }) => {
  return http.post<UserResponse>('/api/auth/refresh', { data })
}

/**
 * 获取用户套餐列表
 * @param data
 * @returns
 */
export const apiPointPackages = (data: { num: number }) => {
  return http.post<any>('/api/user/get/point/packages/list', { data })
}

/**
 * 获取用户剩余总点数
 * @param data
 * @returns
 */
export const apiTotalPoint = () => {
  return http.post<any>('/api/user/total/points')
}

export const apiWsHandshake = () => {
  return http.post<any>('/ws/handshake')
}

export const testEmailLogin = () => {
  let data = {
    client_id: 'R6xx1Dl5jE7HhHKBKPQsPp9gBUfnH9o1',
    connection: 'email',
    send: 'link',
    email: 'lujunjie2012@gmail.com',
    authParams: {
      redirect_uri: 'http://localhost:3000/login/callback',
    },
  }
  return http.post<any>(
    '/passwordless/start',
    { data },
    {
      baseURL: 'https://dev-j60iiqp6h56jufxs.us.auth0.com',
    }
  )
}
